<template>
  <div class="question-block question-block-kpmg">
    <div class="question-block__title">
      <drag-title-block
        class="question-block__drag sortable-handle handleClass"
        :title="i + 1 + $tr('vacancy.tests.form.questions.question.number')"
      />

      <div v-if="disabled_del === false" class="question-block__delete" @click="del_question">
        <i class="icon icon-recycle_bin"></i>
      </div>
    </div>

    <div class="question">
      <div class="question-block__question-body">
        <div class="question-block__question-body-top">
          <multiselect
            v-model="selectedType"
            open-direction="bottom"
            track-by="type"
            label="name"
            class="application-select"
            :options="types"
            :show-labels="false"
            :searchable="false"
            icon_select
            @input="set_type"
          />

          <div v-if="!item._new" class="question__score-container">
            <vinput
              class="question__score"
              placeholder="Макс. балл"
              border
              type="number"
              :disabled="questionsLoading"
              :value="getMaxScoreByQuestionId(item.id)"
              @input="sendQuestionScore({ max_score: $event, question_id: item.id, test_id: testId })"
            />

            <div
              :disabled="!getMaxScoreByQuestionId(item.id)"
              class="question__score-remove"
              @click="deleteQuestionScore({ questionId: item.id, testId: testId })"
            >
              <i class="icon icon-recycle_bin"></i>
            </div>
          </div>
        </div>

        <div class="veditor-block">
          <vcv-editor
            id="toolbar"
            ref="template_editor"
            v-model="question_body"
            file-tooltip="tests.uploadFile"
            :toolbar-buttons="{
              bold: true,
              italic: true,
              underline: true,
              list: true,
              file: true,
              clean: true
            }"
            :class="[
              'editor-invites',
              {
                error_edit: !item.body && check_errors
              }
            ]"
            :placeholder="$tr('vacancy.tests.form.questions.body')"
            :editor-options="toolbarOptions"
            name="descr"
          >
            <template slot="toolbar">
              <button
                v-show="!(has_video || has_audio)"
                v-tooltip.top-center="$tr('editor.uploadImageTooltip')"
                class="ql-image-upload ql-file-wrapper"
                :class="{ 'is-disabled': has_video || has_audio }"
              >
                <input ref="file_image" class="ql-file" type="file" @change="uploadImage" />

                <img src="/static/icons/image-icon.png" alt="Youtube" />
              </button>

              <div v-show="has_video || has_audio" class="image-disabled-icon">
                <img src="/static/icons/image-icon.png" alt="Youtube" />
              </div>

              <div class="ql-youtube" :class="{ 'is-disabled': has_image || has_audio }" @click="youtube_click">
                <img src="/static/icons/ql-youtube-icon.svg" alt="Youtube" />
              </div>

              <button
                v-tooltip.top-center="$tr('editor.uploadAudioTooltip')"
                class="ql-audio"
                :class="{ 'is-disabled': has_image || has_video }"
              >
                <input
                  ref="audio"
                  class="ql-audio-file"
                  :disabled="has_image || has_video"
                  type="file"
                  accept=".mp3,audio/*"
                  @change="change_audio"
                />

                <div class="ql-audio-btn">
                  <img src="/static/icons/ql-audio-icon.png" />
                </div>
              </button>
            </template>
          </vcv-editor>

          <div v-if="has_youtube_link && !has_image && !has_audio" class="video-container-wrap">
            <video-container
              :placeholder="$tr('vacancy.media.youtube_link')"
              :value="youtube_link"
              @setVideoLink="setVideoLink"
              @change_duration="change_duration"
              @set_title="set_video_title"
              @show_modal="toggle_video_modal(true)"
            />
          </div>

          <div v-if="audio && !has_image && !has_video" class="audio-block">
            <vaudio class="audio" :src="audio.src" :name="audio.name" @change_duration="change_duration" />

            <div class="audio-remove" @click="remove_audio">
              <img src="/static/icons/video-close.png" />
            </div>
          </div>

          <div
            v-if="(audio || youtube_link) && !is_page_single"
            class="set_separate_page"
            :class="{ mrb0: !item.has_valid_answer }"
          >
            <vchecklabel
              :label="$tr('vacancy.media.separate_page')"
              :value="is_separate_page"
              @input="set_separate_page"
            />
          </div>
        </div>
      </div>

      <div class="question_answers">
        <div class="check-row" :class="{ 'is-column': item.type === 'value' }">
          <div class="row-block">
            <div v-if="timer" class="timer-block">
              <div class="timer-block-content">
                <div class="timer-block-note">
                  {{ $tr('vacancy.videoInterview.timeForAnswer') }}
                </div>

                <div class="test-time-wrapper">
                  <masked-input
                    v-model="timeLimitNew.h"
                    class="input_block"
                    :class="{
                      error:
                        (is_timer_less_duration && item.time_limit_enabled) || (!isTimeValid && item.time_limit_enabled)
                    }"
                    type="text"
                    placeholder="00"
                    :mask="[/[0-9]/, /[0-9]/]"
                    :keep-char-positions="true"
                    :disabled="!item.time_limit_enabled"
                    @input="set_time_limit"
                  />

                  <span>:</span>

                  <masked-input
                    v-model="timeLimitNew.m"
                    class="input_block"
                    :class="{
                      error:
                        (is_timer_less_duration && item.time_limit_enabled) || (!isTimeValid && item.time_limit_enabled)
                    }"
                    type="text"
                    placeholder="00"
                    :mask="[/[0-5]/, /[0-9]/]"
                    :keep-char-positions="true"
                    :disabled="!item.time_limit_enabled"
                    @input="set_time_limit"
                  />

                  <span>:</span>

                  <masked-input
                    v-model="timeLimitNew.s"
                    class="input_block"
                    :class="{
                      error:
                        (is_timer_less_duration && item.time_limit_enabled) || (!isTimeValid && item.time_limit_enabled)
                    }"
                    type="text"
                    placeholder="00"
                    :mask="[/[0-5]/, /[0-9]/]"
                    :keep-char-positions="true"
                    :disabled="!item.time_limit_enabled"
                    @input="set_time_limit"
                  />
                </div>
              </div>

              <div
                v-if="timer && is_timer_less_duration"
                class="error time-error"
                v-html="$tr('vacancy.tests.media.time_less_duration', { minutes: Math.ceil(duration / 60) })"
              ></div>
            </div>

            <div v-on-clickaway="hideOptions" class="options-dropdown">
              <div class="options-label" :class="{ 'is-active': isOptionsVisible }" @click="toggleOptions">
                {{ $tr('responses.resume.questionnaire.additional') }}
                <img src="/static/images/elements/module-arrow-right.svg" />
              </div>

              <transition name="modal">
                <div v-if="isOptionsVisible" class="options-select options">
                  <div v-if="timer" class="options-select-option">
                    <vchecklabel
                      :label="$tr('vacancy.tests.form.question.time_limit_enabled.checkbox')"
                      :tooltip="{
                        content: $tr('vacancy.tests.form.questions.timer.checkbox.tooltip'),
                        placement: 'auto',
                        classes: 'tight'
                      }"
                      :value="item.time_limit_enabled"
                      @input="set_time_limit_enabled"
                    />
                  </div>

                  <div v-if="item.type !== 'value' && item.type !== 'file'" class="options-select-option">
                    <vchecklabel
                      :label="$tr('vacancy.tests.form.question.noAnswer')"
                      :value="item.correct_answer"
                      @input="set_correct_answer"
                    />
                  </div>

                  <div v-if="item.type === 'value'" class="options-select-option">
                    <vchecklabel
                      :label="$tr('vacancy.tests.form.question.has_valid_answer')"
                      :value="item.has_valid_answer"
                      :tooltip="{
                        content: $tr('vacancy.tests.form.questions.answer.value.checkbox.tooltip'),
                        placement: 'auto',
                        classes: 'tight'
                      }"
                      @input="set_has_valid_answer"
                    />
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <div v-if="item.type !== 'file'" class="answers">
          <div
            v-for="(obj, index) in answers"
            :key="obj._id"
            :class="[
              'answer',
              {
                error: check_empty_answer(obj),
                hide: !item.has_valid_answer && selectedType.type === 'value'
              }
            ]"
          >
            <div class="answer__container">
              <div v-if="item.type !== 'value'" :class="['controls', { disabled: item.correct_answer }]">
                <vfocus-field>
                  <vcheckbox
                    v-if="item.type === 'multichoice'"
                    :value="obj.valid"
                    :disabled="item.correct_answer"
                    :v-tooltip="{
                      content: $tr('vacancy.tests.form.questions.answer.other.checkbox.tooltip'),
                      placement: 'auto',
                      classes: 'tight'
                    }"
                    @input="set_valid($event, obj._id)"
                  />

                  <vcircle
                    v-if="item.type === 'choice'"
                    :value="obj.valid"
                    :v-tooltip="{
                      content: $tr('vacancy.tests.form.questions.answer.other.radio.tooltip'),
                      placement: 'auto',
                      classes: 'tight'
                    }"
                    @input="set_valid($event, obj._id)"
                  />
                </vfocus-field>
              </div>

              <vtextarea
                v-if="item.has_valid_answer || item.type !== 'value'"
                :id="`input-option-${obj._id}`"
                :class="['page_tests_input', { val: item.type === 'value' }]"
                :value="obj.body"
                auto_height
                resizable-y
                :min_height="40"
                :placeholder="$tr('vacancy.tests.form.questions.answers.value.input')"
                :focus="answer_focus"
                :error="answer_error(obj.body)"
                @input="set_answer_body($event, obj._id)"
                @keydown="optionListener($event, index)"
              />

              <vfocus-field v-if="answers.length > 1">
                <div
                  class="answer_delete"
                  :class="{ answer_delete__value: item.type === 'value' }"
                  @click="del_answer(obj._id)"
                ></div>
              </vfocus-field>
            </div>

            <div
              v-if="!obj._new && (item.has_valid_answer || item.type !== 'value')"
              class="question__score-answer-container"
            >
              <vslider
                class="question__slider"
                :value="getAnswerScore(obj._id)"
                :min="-2"
                :max="3"
                :step="0.5"
                :labels="ticksLabels"
                :disabled="answersLoading || !getMaxScoreByQuestionId(item.id)"
                :thumb-size="20"
                label="Балл"
                track-color="#00d26e"
                @change="
                  sendAnswerScore({
                    score: $event,
                    question_id: item.id,
                    answer_id: obj._id,
                    testId: testId
                  })
                "
              />

              <div
                :disabled="!getAnswerScore(obj._id)"
                class="question__score-remove"
                @click="deleteAnswerScore({ answerId: obj._id, testId: testId })"
              >
                <i class="icon icon-recycle_bin"></i>
              </div>
            </div>
          </div>

          <div class="answer answer__new">
            <div v-if="item.type !== 'value'" class="controls disabled">
              <vfocus-field>
                <vcheckbox v-if="item.type === 'multichoice'" :disabled="true" />
                <vcircle v-if="item.type === 'choice'" />
              </vfocus-field>
            </div>

            <div
              v-if="item.has_valid_answer || item.type !== 'value'"
              class="page_tests_input page_tests_input__other"
              :class="{ 'page_tests_input__other-value': item.type === 'value' }"
            >
              <div class="other__add-type other__type" @click="add_answer(item.type === 'value')">
                {{ $tr('vacancy.tests.form.button.add_answer') }}
              </div>
            </div>
          </div>
        </div>

        <div v-else class="answers__type answers__type_file">
          <label class="file-title">{{ $tr('vacancy.preferences.fileUploadLabel') }}</label>

          <div class="file-wrapper">
            <span>{{ $tr('tests.uploadFile') }}</span>

            <div class="actions">
              <icon-upload width="31px" height="20px" />
            </div>
          </div>
        </div>
      </div>

      <modal v-if="is_show_video_modal" redesign :has_footer="false" @close="toggle_video_modal(false)">
        <div slot="header">{{ video_title || '' }}</div>

        <div slot="body">
          <div v-if="youtube_link" class="modal-video">
            <vrecorder class="question_video" :src="youtube_link" :show_recorder="false" show_player is_youtube />
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import VideoContainer from '@/components/shared/VideoContainer.vue';
import Modal from '@/components/Modal.vue';
import MaskedInput from 'vue-text-mask';
import DragTitleBlock from '@/routes_new/inner/vacancy/components/DragTitleBlock';
import { mapState, mapGetters, mapActions } from 'vuex';
import debounce from 'debounce';
import { sortBy } from 'lodash';

export default {
  name: 'Question',

  components: {
    VideoContainer,
    Modal,
    MaskedInput,
    DragTitleBlock
  },

  mixins: [clickaway],

  props: ['item', 'i', 'timer', 'disabled_del', 'active_focus', 'check_errors', 'is_page_single', 'testId'],

  data() {
    return {
      types: [
        {
          id: 'choice',
          type: 'choice',
          name: this.$tr('vacancy.tests.form.questions.types.choice')
        },
        {
          id: 'multichoice',
          type: 'multichoice',
          name: this.$tr('vacancy.tests.form.questions.types.multichoice')
        },
        {
          id: 'value',
          type: 'value',
          name: this.$tr('vacancy.tests.form.questions.types.value')
        },
        { id: 'file', type: 'file', name: this.$tr('vacancy.tests.form.questions.types.file') }
      ],

      type: null,
      textarea_focus: false,
      timestamp: '0',
      answer_focus: false,
      youtube_link: null,
      video_title: '',
      duration: 0,
      has_youtube_link: false,
      file: null,
      audio: null,
      audio_file: null,
      body: null,
      media: null,
      is_separate_page: false,
      is_show_video_modal: false,
      audio_size: 0,
      isOptionsVisible: false,
      timeLimitDefault: null,
      timeRegex: /[0-9][0-9]:[0-5][0-9]/g,
      timeLimitNew: {
        h: '',
        m: '',
        s: ''
      },

      isComponentLoaded: false,
      ticksLabels: ['-2', '-1.5', '-1', '-0.5', '0', '0.5', '1', '1.5', '2', '2.5', '3']
    };
  },

  computed: {
    ...mapState('process/kpmg/test', ['questionsLoading', 'answersLoading']),

    ...mapGetters('process/kpmg/test', ['getMaxScoreByQuestionId', 'getAnswerScore', 'getAnswersScoreSum']),

    answers() {
      const filteredAnswers = this.item.answers.filter(i => !i._deleted);
      const sortedAnswers = sortBy(filteredAnswers, ['sort_order', 'id']);

      return sortedAnswers;
    },

    answers_placeholder() {
      return this.item.type === 'value'
        ? 'vacancy.tests.form.questions.answers.solo.title'
        : 'vacancy.tests.form.questions.answers.multi.title';
    },

    body_error() {
      return this.check_errors && this.item.body === '' ? this.$tr('common.requiredField') : '';
    },

    toolbarOptions() {
      return {
        modules: {
          toolbar: {
            container: `#customToolbar_${this.timestamp}`
          }
        }
      };
    },

    isTimeValid() {
      if (!this.timeLimit) {
        return false;
      }

      return !!this.timeLimit.match(this.timeRegex) && !!this.timeLimit.match(this.timeRegex).length;
    },

    timeLimit: {
      get() {
        if (this.timeLimitDefault !== null) {
          return this.timeLimitDefault;
        }
        return this.item._time_limit;
      },

      set(val) {
        this.timeLimitDefault = val;
      }
    },

    selectedType: {
      get() {
        if (this.type === null) {
          return this.types.find(item => item.id === this.item.type);
        }

        return this.type;
      },

      set(val) {
        this.type = val;
      }
    },

    has_audio() {
      return !!this.audio;
    },

    has_video() {
      return !!this.youtube_link;
    },

    has_image() {
      if (!this.question_body) {
        return false;
      }

      return this.question_body.indexOf('img src=') !== -1;
    },

    is_timer_less_duration() {
      if (!this.timer || !this.duration || !this.item.time_limit_enabled) {
        return false;
      }

      return this.item._time_limit < Math.ceil(this.duration / 60);
    },

    question_body: {
      get() {
        if (this.body !== null) {
          return this.body;
        }
        return this.item ? this.item.body : '';
      },

      set(val) {
        this.body = val;
      }
    },

    valid_check() {
      return this.answers.filter(el => el.valid).length > 1;
    }
  },

  watch: {
    youtube_link(val) {
      if (val) {
        this.media = {
          url: val,
          type: 'youtube',
          title: this.video_title || '',
          is_separate_page: this.is_separate_page,
          vacancy_module_test_question_id: this.item.id || this.item.local_id
        };
      } else {
        this.media = null;
        this.change_duration(0);
        this.is_separate_page = false;
      }
      this.set_media(this.media);
    },

    audio(val) {
      if (val) {
        if (this.audio_file) {
          this.$store
            .dispatch('services/saveCompanyImage', {
              imageUrl: this.audio_file
            })
            .then(data => {
              this.media = {
                url: data.url,
                type: 'audio',
                title: val.name,
                is_separate_page: this.is_separate_page,
                vacancy_module_test_question_id: this.item.id || this.item.local_id
              };
              this.set_media(this.media);
            })
            .catch(err => {
              if (err && err.response && err.response.data && err.response.data.meta) {
                this.$noty.error(err.response.data.meta.error.message);
              }
              this.remove_audio();
            });
        } else {
          this.media = {
            url: val.src,
            type: 'audio',
            title: val.name,
            is_separate_page: this.is_separate_page,
            vacancy_module_test_question_id: this.item.id || this.item.local_id
          };
          this.set_media(this.media);
        }
      } else {
        this.media = null;
        this.is_separate_page = false;
        this.change_duration(0);
        this.set_media(this.media);
      }
    },

    question_body(val) {
      this.set_body(val);
    },

    is_timer_less_duration: {
      immediate: true,
      handler(val) {
        this.$emit('set_timer_less_duration', val);
      }
    }
  },

  beforeMount() {
    const date = new Date();
    this.timestamp = date.getTime();
  },

  mounted() {
    if (this.active_focus) {
      this.textarea_focus = !this.textarea_focus;
    }

    if (this.item._time_limit === 0) {
      this.timeLimitNew.m = '02';
    }

    const time = this.item._time_limit.split(':');
    this.timeLimitNew.h = time[0];
    this.timeLimitNew.m = time[1];
    this.timeLimitNew.s = time[2];

    if (this.item && this.item.media) {
      this.media = Object.assign({}, this.media, {
        ...this.item.media,
        vacancy_module_test_question_id: this.item.id || this.item.local_id
      });
      this.$store.commit('questions/set_media_id', {
        id: this.item._id || this.item.local_id,
        v: this.item._id || this.item.local_id
      });

      if (this.item.media.type === 'audio') {
        this.audio = {
          src: this.item.media.url,
          name: this.item.media.title
        };
      }

      if (this.item.media.type === 'youtube') {
        this.has_youtube_link = true;
        this.setVideoLink(this.item.media.url);
      }

      if (this.item.media.is_separate_page) {
        this.set_separate_page(this.item.media.is_separate_page);
      }
    }

    this.isComponentLoaded = true;
  },

  methods: {
    ...mapActions('process/kpmg/test', [
      'setQuestionScore',
      'deleteQuestionScore',
      'setAnswerScore',
      'deleteAnswerScore'
    ]),

    sendQuestionScore: debounce(function (params) {
      this.setQuestionScore(params);
    }, 1200),

    sendAnswerScore: debounce(function (params) {
      const newSum =
        this.getAnswersScoreSum({ questionId: params.question_id, answerId: params.answer_id }) + Number(params.score);

      if (this.selectedType.type === 'multichoice' && newSum > this.getMaxScoreByQuestionId(params.question_id)) {
        this.deleteAnswerScore({ answerId: params.answer_id, testId: params.testId });
        this.$noty.error('Сумма баллов по ответам не может превышать максимальное количество баллов вопроса');
      } else {
        this.setAnswerScore(params);
      }
    }, 1200),

    toggleOptions() {
      this.isOptionsVisible = !this.isOptionsVisible;
    },

    hideOptions() {
      this.isOptionsVisible = false;
    },

    youtube_click() {
      if (this.has_audio || this.has_image) {
        this.has_youtube_link = false;
        return;
      }
      this.has_youtube_link = !this.has_youtube_link;
      if (!this.has_youtube_link) {
        this.setVideoLink('');
      }
    },

    uploadFile() {
      const files = this.$refs.file.files;
      const file = files[0];

      if (!file) {
        return;
      }
      // const size = file.size ? file.size / 1024 / 1024 : 0;

      if (file) {
        this.$store
          .dispatch('services/saveCompanyImage', {
            imageUrl: file
          })
          .then(data => {
            const href = data.url;

            this.$refs.template_editor.$children[0].quill.clipboard.dangerouslyPasteHTML(
              this.$refs.template_editor.$children[0].quill.getSelection(true).index,
              `<a href="${href}">${this.$tr('editor.uploadFile')}</a>`
            );

            this.$refs.file.value = '';
          })
          .catch(err => {
            if (err && err.response && err.response.data && err.response.data.meta) {
              this.$noty.error(err.response.data.meta.error.message);
            }
            this.$refs.file.value = '';
          });
      } else {
        this.file = null;
      }
    },

    uploadImage() {
      const files = this.$refs.file_image.files;
      const file = files[0];

      if (!file) {
        return;
      }
      // const size = file.size ? file.size / 1024 / 1024 : 0;

      if (file) {
        this.$store
          .dispatch('services/saveCompanyImage', {
            imageUrl: file
          })
          .then(data => {
            const href = data.url;

            this.$refs.template_editor.$children[0].quill.clipboard.dangerouslyPasteHTML(
              this.$refs.template_editor.$children[0].quill.getSelection(true).index,
              ` <img src="${href}"> `
            );

            this.$refs.file.value = '';
          })
          .catch(err => {
            if (err && err.response && err.response.data && err.response.data.meta) {
              this.$noty.error(err.response.data.meta.error.message);
            }
            this.$refs.file.value = '';
          });
      } else {
        this.file = null;
      }
    },

    checkFiles: input => input.files[0] === undefined,
    toggle_video_modal(val) {
      this.is_show_video_modal = val;
    },

    set_video_title(val) {
      this.video_title = val;

      this.media = Object.assign({}, this.media, {
        title: this.video_title || ''
      });

      this.$store.commit('questions/set_video_title', { id: this.item._id, v: this.video_title });
    },

    remove_audio() {
      this.audio = null;
      const input = this.$refs.audio;
      input.type = 'text';
      input.type = 'file';
    },

    check_empty_answer(item) {
      return item.body === '' && this.check_errors;
    },

    change_audio() {
      if (this.has_video || this.has_image) {
        this.remove_audio();
        return;
      }
      this.has_youtube_link = false;
      const files = this.$refs.audio.files;
      const file = files[0];
      this.audio_file = files[0];
      this.audio_size = this.audio_file.size ? this.audio_file.size / 1024 / 1024 : 0;
      if (this.audio_size > 10) {
        this.$noty.error(this.$tr('interview.tests.media.audio_limit'));
      }

      this.audio = {
        src: URL.createObjectURL(file),
        name: file.name
      };
    },

    setVideoLink(val) {
      this.youtube_link = val;
    },

    change_duration(val) {
      this.duration = val;
      this.$emit('change_duration', {
        id: this.item._id,
        duration: val
      });
    },

    question_error(v) {
      if (v === '' && this.check_errors) {
        return this.$tr('common.requiredField');
      } else {
        return '';
      }
    },

    answer_error(v) {
      if (v === '' && this.check_errors) {
        return this.$tr('common.requiredField');
      } else {
        return '';
      }
    },

    set_answer_body(v, id) {
      // if(this.item.type === 'value') {
      //   this.$store.commit('questions/set_value_body', {v, question_id: this.item._id})
      // } else {
      //   this.$store.commit('questions/set_answer_body', {v, answer_id: id, question_id: this.item._id});
      // }
      this.$store.commit('questions/set_answer_body', {
        v,
        answer_id: id,
        question_id: this.item._id
      });
      this.update();
    },

    setFocusOnLastOption() {
      this.$nextTick().then(() => {
        document.getElementById(`input-option-${this.answers[this.answers.length - 1]._id}`).focus();
      });
    },

    optionListener(e, indexAnswer) {
      const value = e.target.value;

      if (this.answers.length - 1 !== indexAnswer) return;

      switch (e.keyCode) {
        case 13: // Enter
          this.add_answer();
          this.setFocusOnLastOption();
          break;
        case 8: // backspace
        case 46: // delete
          if (this.answers.length < 2 || value.length !== 0) break;
          this.del_answer(this.answers[indexAnswer]._id);
          this.setFocusOnLastOption();
          break;
      }
    },

    set_body(v) {
      this.$emit('input', { body: v, id: this.item._id });
      this.update();
    },

    set_type(v) {
      this.$emit('input', { type: v && v.id ? v.id : v, id: this.item._id });
      this.update();
      if (v && v.id === 'file') {
        this.set_has_valid_answer(false);
      }
    },

    del_question() {
      this.$store.commit('questions/del_item', this.item._id);
      this.update();
    },

    add_answer(isValid = false) {
      let obj = {};
      if (isValid) {
        obj.valid = true;
      }
      // obj._new = true;
      this.$store.commit('questions/add_answer', { id: this.item._id, _new: true, obj });
      this.update();
      this.answer_focus = true;
    },

    del_answer(id) {
      this.$store.commit('questions/del_answer', { id, question_id: this.item._id });
      this.update();
    },

    set_valid(v, id) {
      if (!this.valid_check && !v) {
        return;
      } else {
        this.$store.commit('questions/set_answer_is_valid', {
          v,
          answer_id: id,
          question_id: this.item._id
        });
        this.update();
      }
    },

    set_media(v) {
      this.$store.commit('questions/set_media', { v, question_id: this.item._id });
      this.update();
    },

    set_has_valid_answer(value, is_no_answer = false) {
      const v = !is_no_answer ? value : !value;

      this.$store.commit('questions/set_has_valid_answer', { id: this.item._id, v });
      this.update();
    },

    set_correct_answer(value, is_no_answer = false) {
      const v = !is_no_answer ? value : !value;

      this.$store.commit('questions/set_correct_answer', { id: this.item._id, v });
      this.update();
    },

    set_separate_page(v) {
      this.is_separate_page = v;
      this.$store.commit('questions/set_separate_page', { id: this.item._id, v });
      if (this.media) {
        this.media = Object.assign({}, this.media, {
          is_separate_page: v
        });
      }
    },

    sort_up() {
      this.$store.commit('questions/sort_up', this.item._id);
      this.update();
    },

    sort_down() {
      this.$store.commit('questions/sort_down', this.item._id);
      this.update();
    },

    set_time_limit_enabled(v) {
      this.$store.commit('questions/set_time_limit_enabled', { id: this.item._id, v });
      this.update();
    },

    set_time_limit() {
      if (!this.isComponentLoaded) return;

      let time = `${this.timeLimitNew.h ? this.timeLimitNew.h : '00'}:`;

      time += `${this.timeLimitNew.m ? this.timeLimitNew.m : '00'}:`;
      time += `${this.timeLimitNew.s ? this.timeLimitNew.s : '00'}`;

      this.$store.commit('questions/set_time_limit', { id: this.item._id, val: time });
      this.update();
    },

    update() {
      this.$emit('update', true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.question-block {
  position: relative;
  box-shadow: $box-shadow;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid $grey-light;
  background: $white;

  &.is-saving {
    opacity: 0.7;
    pointer-events: none;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $grey-light;
  }

  &__drag {
    flex: 1;
  }

  &__question-body {
    padding: 15px 20px;
  }

  &__question-body-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .multiselect {
      max-width: 270px !important;
    }
  }

  &__delete {
    width: 47px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    color: $red;
    background: $background;
    transition: all ease-in-out 0.3s;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover {
      background: $red-light;
      color: $white;
      transition: all 0.3s;
    }
  }
}

.question {
  margin-left: 0;
  position: relative;

  &__score-container {
    display: flex;
    align-items: center;
  }

  &__score-answer-container {
    width: 100%;
    display: flex;
    align-items: center;
  }

  &__score {
    margin-left: 5px;
    width: 110px;
  }

  &__slider {
    width: 100%;
  }

  &__score-remove {
    margin-left: 15px;
    cursor: pointer;
    color: #7f8b99;
    transition: color ease-in-out 0.4s;

    &:hover {
      color: #607182;
    }
  }

  .question_content {
    display: flex;
    align-items: flex-start;

    .error_edit {
      border: 1px solid #f65046;
    }
    .veditor-block {
      flex: 1;
      max-width: 100%;
      margin-bottom: 8px;
    }
    .question_delete {
      position: absolute;
      right: -64px;
      top: 5px;
      min-width: 40px;
      max-width: 40px;
      min-height: 40px;
      max-height: 40px;
      cursor: pointer;
      color: #7f8b99;
      transition: color ease-in-out 0.4s;

      &:hover {
        color: #607182;
      }
    }
  }
  .question_answers {
    margin-left: 0;
    padding: 20px;
  }

  .question-title {
    margin-right: 28px;
  }
  .check-row {
    display: flex;
    align-items: center;
    margin-bottom: 6px;

    &.is-column {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .check-block {
    margin-bottom: 12px;
  }
  .page_tests_textarea {
    max-width: 602px;
    min-width: 602px;
    min-height: 120px;
    max-height: 120px;
    margin-bottom: 35px;
  }
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    letter-spacing: 0.4px;
    color: rgba(33, 51, 71, 0.8);
    margin-bottom: 10px;
  }
  .margin_b {
    margin-bottom: 35px;
  }
  .maxwid_wrapper {
    margin-top: 20px;
  }
  .maxwid {
    max-width: 215px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .answers {
    .answer {
      position: relative;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: 24px;

      &__new {
        flex-direction: row;
        align-items: center;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &.hide {
        display: none;
      }

      &__container {
        width: 100%;
        display: flex;
        align-items: center;
      }

      &.row {
        flex-direction: row;
        padding: 0 10px;
        align-items: center;
      }

      .controls {
        display: flex;
        align-items: center;
        min-width: 18px;
        max-width: 18px;
        justify-content: center;
        margin-bottom: 0;
        margin-top: 0;
        margin-right: 17px;
        min-height: 18px;
        max-height: 18px;
        position: relative;
        &:hover {
          background-color: rgba(244, 245, 247, 0.56);
        }
        &.disabled {
          opacity: 0.5;
          &:before {
            position: absolute;
            top: 0;
            left: 0;
            content: '';
            width: 100%;
            height: 100%;
            background: transparent;
            z-index: 99;
            cursor: not-allowed;
          }
        }
      }
      ::v-deep {
        .vinput:not(.val) {
          .input {
            padding: 10px 6px;
          }
        }
      }
    }
  }
  .answer_delete {
    width: 15px;
    height: 15px;
    transform: translateY(0);
    margin-right: 15px;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      top: 0;
      right: 50%;
      content: '';
      display: block;
      width: 2px;
      height: 18px;
      background: #7f8b99;
    }

    &:hover {
      &:before,
      &:after {
        background: #607182;
      }
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }

    &.answer_delete__value {
      top: 50%;
      right: -36px;
    }
  }
  ::v-deep {
    .page_tests_input {
      flex: 1;
      margin-top: 0;

      &.val {
        margin-left: 0px;

        &.vinput .input {
          background: #ffffff;
          border: 1px solid #d2d6e0;
          border-radius: 2px;
        }
      }
    }
  }
  .page_tests_input__other {
    width: 100%;
    padding: 10px 6px;
    border-radius: 0;
    border-bottom: 1px solid #d2d6e0;
    min-height: 40px;
    max-height: 40px;
    box-sizing: border-box;
    color: #9faab6;

    &.page_tests_input__other-value {
      border-bottom: 0;
    }
  }
  .use_true_answer {
    display: flex;
    align-items: center;
    .checkbox_label {
      margin-left: 20px;
    }
  }
  .set_separate_page {
    display: flex;
    align-items: center;
    margin-top: 18px;
    .checkbox_label {
      margin-left: 20px;
    }
  }
  .mrb0 {
    margin-bottom: 0;
  }
  .small_input {
    max-width: 30px;
    min-width: 30px;
    margin-left: 2px;
    margin-right: 12px;

    ::v-deep {
      .input {
        padding: 1px 0px;
        min-height: 20px;
        max-height: 20px;
        width: 30px;
        min-width: auto;
      }
    }
  }
  .checkboxer {
    display: flex;
    align-items: center;
    margin-top: 35px;

    &.no-margin-top {
      margin: 0;
    }
  }
}

.test-time-wrapper {
  display: flex;
  align-items: center;

  .input_block {
    @include mixin-text-main;
    width: 43px !important;
    margin: 0 8px !important;
  }
}

.audio {
  margin-top: 20px;
  margin-bottom: 15px;
  flex: 1;
}

.audio-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.audio-remove {
  cursor: pointer;
  margin-left: 10px;
}

.ql-audio-btn {
  cursor: pointer;
}

.ql-upload-btn {
  width: 18px;
  height: 18px;
}

.ql-audio {
  position: relative;
  width: 18px !important;
  height: 18px !important;
  position: relative;
  padding: 0 !important;
  margin-right: 20px;
  cursor: pointer;

  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.5;

    .ql-audio-btn {
      cursor: not-allowed;
    }

    * {
      cursor: not-allowed;
    }
  }
}

.ql-youtube {
  cursor: pointer;
  width: 17px !important;
  height: 16px !important;
  position: relative;
  padding: 0 !important;
  margin-right: 20px;
}

.ql-image,
.ql-youtube {
  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.image-disabled-icon {
  cursor: not-allowed;
  opacity: 0.5;
  width: 22px !important;
  height: 16px !important;
  position: relative;
  padding: 0 !important;
  margin-right: 20px;
}

.ql-file {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100% !important;
  left: 0;
  top: 0;
  cursor: pointer;
}

.ql-audio-file {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100% !important;
  left: 0;
  top: 0;
  cursor: pointer;
}

.customToolbar {
  display: flex;
  align-items: center;
}

.ql-formats {
  display: flex !important;
  align-items: center;
}

.video-container-wrap {
  margin-top: 20px;
}
.modal-video {
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 -90px 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.time-error {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.005em;
  color: #f65046;
  margin-top: 4px;
}

.timer-block-content {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  line-height: 24px;
}

.timer-block-note {
  margin-right: 4px;
}

::v-deep input.time_input {
  width: 72px;
  padding: 8px 11px;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
}
.test-question-block {
  ::v-deep {
    .application-select.multiselect {
      width: 236px;
      max-width: 236px;
      margin-left: auto;
      height: 40px;
    }

    .ql-toolbar.ql-snow {
      padding: 5px 0px;
      border-bottom: 0;
    }
  }
}

.sort_controls {
  display: flex;
  position: relative;
  justify-content: space-between;
  margin-bottom: 10px;
  .arrow {
    min-width: 40px;
    max-width: 40px;
    min-height: 20px;
    max-height: 20px;
    cursor: pointer;
    background: url('/static/images/elements/arrow_n.svg') 14px center no-repeat;
    &:hover {
      background-color: rgba(244, 245, 247, 0.56);
    }
    &.up {
      margin-bottom: 1px;
    }
    &.down {
      background-position: 13px center;
      transform: rotate(-180deg);
    }
  }
}
.dragging__dots {
  cursor: grab;
  text-align: center;
  display: block;
  position: absolute;
  top: 3px;
  left: -15px;

  .dragging__dot {
    width: 4px;
    height: 4px;
    background-color: #d2d6e0;
    border-radius: 50%;
    margin: 3px 2px;
    display: block;
  }
}

.question_title {
  font-weight: 500;
  font-size: 22px;
  line-height: 32px;
  color: #233346;
}

.other__add-type {
  cursor: pointer;
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 100%;
  color: #9faab6;
  display: inline-block;
  vertical-align: top;

  &:hover {
    color: #607182;
  }
}

.options-dropdown {
  @include mixin-text-main;
  background: $white;
  position: relative;
  margin-left: auto;
}

.options-label {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 17px 8px 8px;
  border: 1px solid #d2d6e0;
  box-sizing: border-box;
  border-radius: 2px;
  min-width: 200px;
  cursor: pointer;

  img {
    transition: all ease-in-out 0.4s;
    transform: rotate(90deg);
  }

  &.is-active {
    img {
      transition: all ease-in-out 0.4s;
      transform: rotate(270deg);
    }
  }
}

.options-select {
  position: absolute;
  background: #fff;
  border: 1px solid #d2d6e0;
  box-sizing: border-box;
  border-radius: 2px;
  right: 0;
  top: 45px;
  padding: 10px 10px;
  z-index: 2;
  transition: all ease-in-out 0.4s;

  ::v-deep {
    .vcheckbox_label,
    .checkbox_label {
      white-space: nowrap;
    }
  }
}

.checkbox_label {
  margin-left: 10px !important;
  line-height: 1.4 !important;
}

.options-select-option {
  margin-bottom: 18px;

  &:last-child {
    margin-bottom: 0;
  }
}

.row-block {
  align-self: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 0;
  margin-bottom: 12px;
}
.question .ql-snow.ql-toolbar button.ql-audio,
.question .ql-snow.ql-toolbar button.ql-audio-btn {
  width: 18px !important;
  height: 18px !important;
  position: relative;
  padding: 0 !important;
  margin-right: 20px;

  img {
    max-width: 100%;
  }
}
.question .ql-snow.ql-toolbar button.ql-image,
.question .ql-snow .ql-toolbar button.ql-image,
.ql-image {
  background: url('/static/icons/image-icon.png') 0 0 no-repeat !important;
  width: 22px !important;
  height: 16px !important;
  position: relative;
  padding: 0 !important;
  margin-right: 20px;

  svg {
    display: none;
  }
}

.medium-text {
  font-weight: 700;
}

.answers {
  &__trigger {
    margin-right: 10px;
  }

  &__type {
    &_choice {
      margin-top: 7px;

      .choice-answer {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        position: relative;

        &__delete {
          width: 15px;
          height: 15px;
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;

          &:before,
          &:after {
            position: absolute;
            top: 0;
            right: 50%;
            content: '';
            display: block;
            width: 2px;
            height: 18px;
            background: #d2d6e0;
          }

          &:before {
            transform: rotate(45deg);
          }

          &:after {
            transform: rotate(-45deg);
          }
        }

        .choice-input {
          width: 100%;
          margin-left: 17px;
          color: #9faab6;
        }

        .other {
          width: 100%;
          margin-left: 20px;
          padding: 10px;
          border-bottom: 1px solid #d2d6e0;
          color: #9faab6;
          display: flex;
          align-items: center;
          font-size: 15px;

          &.has-error {
            border-color: #f65046;
          }

          &__type {
            cursor: pointer;
            margin-right: 4px;
            font-weight: 500;
            position: relative;

            &:hover {
              color: #607182;
            }
          }

          &__add-type {
            position: relative;

            &:hover {
              color: #607182;
            }
          }

          span {
            font-weight: 500;
          }
        }
      }

      .answer {
        border: 2px solid #dadada;
      }
    }

    &_date {
      margin-top: 19px;
      position: relative;

      .date__range {
        width: 150px;
        padding: 10px 20px;
        border: 1px solid #d2d6e0;
        color: #9faab6;
      }

      ::v-deep {
        .vcheckbox_label .checkbox_label {
          margin-left: 10px;
        }
      }
    }

    &_file {
      margin-top: 12px;

      .file-title {
        font-size: 15px;
        line-height: 22px;
        color: #233346;
        display: block;
      }

      .file-wrapper {
        position: relative;
        min-width: 300px;
        margin-top: 4px;
        border: 1px solid #d2d6e0;
        padding: 11px 42px 11px 11px;
        display: inline-block;
        border-radius: 2px;
        color: #9faab6;
        font-size: 15px;

        .actions {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
        }
      }
    }
  }
}

.question-block-kpmg {
  .input_block {
    width: 47px;
  }

  ::v-deep .ql-toolbar.ql-snow {
    display: flex;
    align-items: center;
  }

  .answer_delete {
    margin-right: auto;
    margin-left: 15px;
  }
}
</style>
